import toast

from "react-hot-toast";

export function toastSuccess(message){

    toast.success(message);

}

export function toastError(message){

    toast.error(message);

}


export function success(message){

    toast.success(message);

}

export function error(message){

    toast.error(message);

}